import repository from '@/repositories/repository'

export default baseUrl => {

    baseUrl = `${baseUrl}/livro`

    const headers = { responseType: "arraybuffer" }

    return {
        livro(id) {

            return repository.get(`${baseUrl}/${id}`, headers)
        },
        termoFechamento(livroId) {

            return repository.get(`${baseUrl}/termo-fechamento/${livroId}`, headers)
        },
    }
}
